import * as AlertDialog from "@radix-ui/react-alert-dialog";
import { type ReactNode } from "react";

import { Button } from "./button";
import { cn } from "./cn";

type ConfirmDialogProps = {
  trigger: ReactNode;
  title: string;
  description: ReactNode;
  confirmLabel: string;
  /** Destructive actions get a red confirm button. */
  destructive?: boolean;
  onConfirm: () => void;
};

export const ConfirmDialog = ({
  trigger,
  title,
  description,
  confirmLabel,
  destructive = false,
  onConfirm,
}: ConfirmDialogProps) => (
  <AlertDialog.Root>
    <AlertDialog.Trigger asChild>{trigger}</AlertDialog.Trigger>
    <AlertDialog.Portal>
      <AlertDialog.Overlay className="fixed inset-0 z-40 bg-ink/30 backdrop-blur-[1px]" />
      <AlertDialog.Content className="fixed left-1/2 top-1/2 z-50 w-[min(28rem,calc(100vw-2rem))] -translate-x-1/2 -translate-y-1/2 rounded-xl border border-line bg-white p-6 shadow-xl">
        <AlertDialog.Title className="font-serif text-lg text-ink">{title}</AlertDialog.Title>
        <AlertDialog.Description className="mt-2 text-sm text-muted">
          {description}
        </AlertDialog.Description>
        <div className="mt-6 flex justify-end gap-2">
          <AlertDialog.Cancel asChild>
            <Button variant="secondary">Cancel</Button>
          </AlertDialog.Cancel>
          <AlertDialog.Action asChild>
            <Button
              className={cn(destructive && "bg-red-600 hover:bg-red-700")}
              onClick={onConfirm}
            >
              {confirmLabel}
            </Button>
          </AlertDialog.Action>
        </div>
      </AlertDialog.Content>
    </AlertDialog.Portal>
  </AlertDialog.Root>
);
